<template>
  <div v-if="!isMobile()">
    <NavbarDesktop />
  </div>
  <div v-else>
    <NavbarMobile />
  </div>
</template>

<script>
import NavbarDesktop from './NavbarDesktop.vue'
import NavbarMobile from './NavbarMobile.vue'

export default {
  name: 'Navbar',
  components: {
    NavbarDesktop,
    NavbarMobile,
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>
<style scoped>
</style>
